<script setup lang="ts">
import {Badge} from "@/core/components/ui/badge";
import {CreditCard} from "@lucide/vue";
</script>

<template>
  <Badge variant="outline" class="gap-1.5 border-green-200 bg-green-50 text-green-700">
    <CreditCard class="w-3.5 h-3.5 shrink-0" />
    Payée en ligne
  </Badge>
</template>
